import { Button } from '@/shared/ui/Button'
import { BackButton } from '@/shared/ui/BackButton'
import { Card } from '@/shared/ui/Card'
import { openExternal } from '@/shared/lib/platform/browser'

const PWA_PUBLIC_ORIGIN = 'https://app.synap.med.br'

export interface UnavailableInNativeAppProps {
  featureName: string
  reason: string
  /** Caminho na PWA (ex.: `/doctor/settings/local-ai`). */
  pwaPath: string
}

const buildPwaUrl = (pwaPath: string): string => {
  const path = pwaPath.startsWith('/') ? pwaPath : `/${pwaPath}`
  return `${PWA_PUBLIC_ORIGIN}${path}`
}

export const UnavailableInNativeApp = ({
  featureName,
  reason,
  pwaPath,
}: UnavailableInNativeAppProps) => {
  const handleOpenInBrowser = () => {
    void openExternal(buildPwaUrl(pwaPath))
  }

  return (
    <Card>
      <div className="space-y-3 px-1 py-2">
        <BackButton fallbackTo="/dashboard" alwaysGoToFallback aria-label="Voltar" className="!mb-0" />
        <h1 className="text-lg font-semibold text-[var(--color-text-primary)]">
          {featureName} indisponível no app
        </h1>
        <p className="text-sm text-[var(--color-text-muted)]">{reason}</p>
        <Button type="button" onClick={handleOpenInBrowser}>
          Abrir no navegador
        </Button>
      </div>
    </Card>
  )
}
